import { render, staticRenderFns } from "./WeixinLoginUser.vue?vue&type=template&id=cc973d36&scoped=true"
import script from "./WeixinLoginUser.vue?vue&type=script&lang=js"
export * from "./WeixinLoginUser.vue?vue&type=script&lang=js"
import style0 from "./WeixinLoginUser.vue?vue&type=style&index=0&id=cc973d36&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc973d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc973d36')) {
      api.createRecord('cc973d36', component.options)
    } else {
      api.reload('cc973d36', component.options)
    }
    module.hot.accept("./WeixinLoginUser.vue?vue&type=template&id=cc973d36&scoped=true", function () {
      api.rerender('cc973d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/weixinLoginUser/WeixinLoginUser.vue"
export default component.exports